import { render, staticRenderFns } from "./Fraud.vue?vue&type=template&id=8fac3ea6&scoped=true&"
import script from "./Fraud.vue?vue&type=script&lang=js&"
export * from "./Fraud.vue?vue&type=script&lang=js&"
import style0 from "./Fraud.vue?vue&type=style&index=0&id=8fac3ea6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fac3ea6",
  null
  
)

export default component.exports